export const AUTHORIZATION_FIELDS = [
  // {
  //   key: "medical_authorization",
  //   title: "Autoriza consulta médica",
  // },
  // {
  //   key: "data_authorization",
  //   title: "Autoriza tratamiento de datos",
  // },
  {
    key: "inss_authorization",
    title: "Autoriza gestión INSS",
  },
];
